import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { CompanyDashboard } from "./CompanyDashboard";
import { AssimagraDashboard } from "./AssimagraDashboard";

export const Dashboard = () => {
  const { claims, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !claims?.role) {
      navigate("/login");
    }
  }, [claims, loading, navigate]);

  // Show loading state while auth is initializing
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  switch (claims?.role) {
    case "company":
      return <CompanyDashboard />;
    case "assimagra":
    case "get2c":
      return <AssimagraDashboard />;
    default:
      return null;
  }
};
